<template>
  <div>
    <Navbar />
    <!-- Start Main Banner Area -->
    <div class="main-banner-area">
      <div class="container-fluid">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="d-table">
              <div class="d-table-cell">
                <div class="main-banner-content">
                  <span>Trauma Healing Centre</span>
                  <h1>Ensuring healing and wholeness of an individual</h1>

                  <div class="banner-btn">
                    <a class="optional-btn" href="/register">
                      Become Member
                      <i class="flaticon-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-md-12">
            <div class="banner-slider-wrap">
              <div class="banner-image-slider owl-carousel owl-theme">
                <div class="image-item">
                  <img
                    class="image"
                    src="assets/img/thc/thc6.JPG"
                    alt="image"
                  />
                </div>

                <div class="image-item">
                  <img
                    class="image"
                    src="assets/img/thc/thc1.JPG"
                    alt="image"
                  />
                </div>

                <div class="image-item">
                  <img
                    class="image"
                    src="assets/img/thc/thc5.JPG"
                    alt="image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="banner-shape">
        <img src="assets/img/home-two/shape.png" alt="image" />
      </div>
    </div>
    <!-- End Main Banner Area -->

    <!-- Start Feature Area -->
    <section class="features-section ptb-100">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6">
            <div class="feature-content">
              <span>Services</span>
              <h3>Biblical and mental health resources</h3>
              <p>
                Helping traumatised people experience the life-changing message
                of the Bible.
              </p>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="feature-slider owl-carousel owl-theme">
              <div class="feature-card mx-4">
                <div class="icon">
                  <img src="assets/img/icon/1.png" alt="image" />
                  <img src="assets/img/icon/white-1.png" alt="image" />
                </div>

                <h3>Who we are</h3>
                <p>
                  This is a support group to the ministerial work of Dr,
                  Goodhead Uchendu. The trauma healing centre of the CLC
                  Botswana has partnered with the Botswana Police Force and the
                  university counsellor at the University of Botswana to provide
                  victim support and healing.
                </p>
              </div>

              <div class="feature-card mx-4">
                <div class="icon">
                  <img src="assets/img/icon/2.png" alt="image" />
                  <img src="assets/img/icon/white-2.png" alt="image" />
                </div>

                <h3>Our Mission</h3>
                <p>
                  To assist the youth to clearly discover their potentials
                  thoroughly develop and maximally devout them for the
                  fulfilment of their purpose as their contribution to the
                  fulfilment of the overall purpose of mankind on earth.
                </p>
              </div>

              <div class="feature-card mx-4">
                <div class="icon">
                  <img src="assets/img/icon/3.png" alt="image" />
                  <img src="assets/img/icon/white-3.png" alt="image" />
                </div>

                <h3>Our Vision</h3>
                <p>
                  To help the youth clearly discover his\her person and
                  potentials maximally develop character and potentials Fully
                  deploy potentials for fulfilment of his purpose as his
                  contribution to the fulfilment of the overall purpose of
                  mankind
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Feature Area -->

    <!-- Start About Area -->
    <section class="about-area">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-6 p-0">
            <div class="about-image ptb-100">
              <img src="assets/img/thc/thc3.JPG" alt="image" />
            </div>
          </div>

          <div class="col-lg-6">
            <div class="about-item about-item-two ptb-100">
              <span>
                <i class="flaticon-care-about-plants"></i>
                Role Of American Bible Society In Mitigating Trauma
              </span>
              <p>
                The trauma healing programs organised by the American Bible
                Society equip local Christian leaders with biblical and mental
                health resources needed to help traumatised people experience
                the life-changing message of the Bible. Through multi
                partnerships in applying Bible-based trauma healing programs and
                resources, the THI at ABS provides training, accountability,
                implementation, reporting and assessment to make these programs
                effective in bringing holistic healing through God’s word.
              </p>

              <div class="about-btn">
                <a href="/register" class="default-btn">
                  Join
                  <i class="flaticon-right"></i>
                  <span></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End About Area -->

    <section class="testimonials-section pt-100 pb-100">
      <div class="container">
        <div class="section-title">
          <span>
            <i class="flaticon-testimonial"></i>
            Achievements And Goals
          </span>
          <h2>What we've done and our Bucket List</h2>
        </div>

        <div class="row border-hide">
          <div class="testimonials-slider-two owl-carousel owl-theme">
            <div class="testimonials-area-content">
              <h3>Achievement in 2019</h3>
              <ul>
                <li>
                  From April 27 to May 3, 2019 Trauma Healing Institute of ABS
                  trained 17 locals producing 14 Apprentice Facilitator and 3
                  ordinary participants
                </li>
                <li>
                  Since May 2019, the Centre has counselled over 100 locals on
                  different kinds of trauma
                </li>
                <li>
                  In December, 2019 the Centre visited some four prisons in
                  village Gaborone with massage of hope and over 100 inmates
                  received salvation for their souls in addition to gift items.
                </li>
                <li>
                  The centre has conducted Radio program for motivational
                  sessions for youths and teenagers
                </li>
              </ul>
            </div>

            <div class="testimonials-area-content">
              <h3>Looking Forward: 2020 and Beyond</h3>
              <ul>
                <li>
                  Quarterly upgrade training for registered trauma Healing
                  Facilitators
                </li>
                <li>
                  Continued free counselling for locals on different kinds of
                  trauma
                </li>
                <li>
                  Continued visit to the prisons and other correctional centres
                  in Botswana with massage of hope
                </li>
                <li>
                  Radio program for motivational sessions for youths and
                  teenagers
                </li>
                <li>
                  Accreditation by BQA, which allows facilitators to train
                  locals and other interested volunteers
                </li>
                <li>
                  Accreditation of RPC Trauma Healing Centre as a Certified
                  American Trauma Healing Centre in SADC: possibility of
                  generating international recognition for Botswana
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Footer from "../../Footer";

export default {
  components: {
    Navbar,
    Footer
  },
  data() {
    return {
      src:
        "https://docs.google.com/forms/d/e/1FAIpQLSdM6HhRloSIC-esVhVN7sQTJ1TpRbidrJdqOXg-GhwB1Jpo6A/viewform"
    };
  },
  mounted() {
    window.jQuery('.feature-slider').owlCarousel({
      loop: true,
      nav: false,
      dots: true,
      autoplayHoverPause: true,
      autoplay: true,
      smartSpeed: 1000,
      margin: 30,
      items: 1
    });
  }
};
</script>

<style scoped>
.team-img {
  height: 300px;
}
</style>
